
export enum TsAndCsDisplayLocation {
    ProfileMenu = 1,
    MyDocumentsPageText = 10,
}